import { BaseIconProps } from '@c/icons/types';

export const Play = ({ className }: BaseIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M6.25293 3.41016C6.54157 3.41379 6.82373 3.49543 7.07031 3.64551H7.07129L18.6885 10.5996C18.9254 10.7482 19.1205 10.9545 19.2559 11.1992C19.3913 11.444 19.4629 11.7192 19.4629 11.999C19.4629 12.2788 19.3913 12.554 19.2559 12.7988C19.1205 13.0435 18.9253 13.2498 18.6885 13.3984L7.06934 20.3545L7.06836 20.3555C6.8161 20.5078 6.52714 20.5887 6.23242 20.5898L6.02246 20.5762C5.81445 20.5486 5.61298 20.4808 5.42969 20.376C4.87878 20.0638 4.53516 19.4566 4.53516 18.7969V5.20312C4.53518 4.54159 4.87882 3.93719 5.42969 3.625V3.62402C5.67992 3.48026 5.96436 3.40654 6.25293 3.41016Z"
        fill="white"
        stroke="white"
        stroke-width="0.0703125"
      />
    </svg>
  );
};
